import { useCallback, useEffect, useState } from "react";
import { mh, useMhStream, upsertRun } from "@/lib/mh";

export function useLiveRuns(department, max = 20) {
  const [runs, setRuns] = useState([]);
  useEffect(() => {
    mh.runs({ department, limit: max }).then((r) => setRuns(r.data)).catch(() => {});
  }, [department, max]);
  useMhStream((ev) => {
    if (!ev.run) return;
    if (department && ev.run.department !== department) return;
    setRuns((list) => upsertRun(list, ev.run, max));
  });
  return runs;
}

export function useApprovals(department) {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [pageSize] = useState(50);
  const load = useCallback(() => {
    mh.approvals({ status: "pending", department, page, page_size: pageSize }).then((r) => {
      // Backwards-compat: new API returns {items,total,page,page_size,pages}; legacy returned a bare array.
      if (Array.isArray(r.data)) { setItems(r.data); setTotal(r.data.length); }
      else { setItems(r.data.items || []); setTotal(r.data.total || 0); }
    }).catch(() => {});
  }, [department, page, pageSize]);
  useEffect(load, [load]);
  useMhStream((ev) => {
    if (ev.type === "approval.requested" && (!department || ev.approval.department === department)) {
      setItems((l) => [ev.approval, ...l.filter((a) => a.id !== ev.approval.id)]);
      setTotal((t) => t + 1);
    }
    if (ev.type === "approval.decided") {
      setItems((l) => l.filter((a) => a.id !== ev.approval.id));
      setTotal((t) => Math.max(0, t - 1));
    }
  });
  return { items, total, page, pageSize, setPage, reload: load };
}

export function useDeptMap() {
  const [map, setMap] = useState({});
  useEffect(() => {
    mh.departments().then((r) => setMap(Object.fromEntries(r.data.map((d) => [d.slug, d])))).catch(() => {});
  }, []);
  return map;
}
